import { Button, Form, Input, Col, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { recoverUserPassword } from "../../services/authApi";
import { WebRoutes } from "../../shared/constants/WebRoutes";
import ContainerLayout from "../common/containerLayout";
import "./styles.css";

const { Title } = Typography;

const RecoverPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [form] = Form.useForm();

  useEffect(() => {
    const email = searchParams.get("email");
    if (email) {
      form.setFieldsValue({ email });
    }
  }, [form, searchParams]);

  const onFinish = async (values: any) => {
    const { email, codeRecovery, password } = values;
    setIsLoading(true);

    await recoverUserPassword(email, codeRecovery, password)
      .then(() => {
        navigate(WebRoutes.LoginRoute, { replace: true });
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <ContainerLayout showNotification={false} defaultContainer={false}>
        <Col
          style={{
            height: "94.3vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            overflowY: "hidden",
          }}
        >
      <Row justify="center">
        <Title>Restablecer contraseña</Title>
      </Row>
      <Row justify="center">
        <Typography.Paragraph>
          Ingresa tu correo, el código recibido y la nueva contraseña para
          completar el restablecimiento.
        </Typography.Paragraph>
      </Row>
      <Row className="form-container">
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item
            label="Correo electrónico"
            name="email"
            rules={[
              {
                required: true,
                message: "Por favor ingresa un correo",
              },
              {
                type: "email",
                message: "Por favor ingresa un correo válido",
              },
            ]}
          >
            <Input placeholder="correo@ejemplo.com" />
          </Form.Item>

          <Form.Item
            label="Código de recuperación"
            name="codeRecovery"
            rules={[
              {
                required: true,
                message: "Por favor ingresa el código",
              },
            ]}
          >
            <Input placeholder="Código recibido" />
          </Form.Item>

          <Form.Item
            label="Nueva contraseña"
            name="password"
            rules={[
              {
                required: true,
                message: "Por favor ingresa una contraseña",
              },
              {
                min: 7,
                message: "La contraseña debe tener al menos 7 caracteres",
              },
            ]}
            hasFeedback
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            name="confirm"
            label="Confirmar contraseña"
            dependencies={["password"]}
            hasFeedback
            rules={[
              {
                required: true,
                message: "Por favor confirma la contraseña",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Las contraseñas no coinciden!"),
                  );
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            className="button-container"
            loading={isLoading}
          >
            Restablecer contraseña
          </Button>
          <Button
            type="link"
            onClick={() => navigate(WebRoutes.LoginRoute)}
            style={{ marginTop: 12 }}
          >
            Volver al login
          </Button>
        </Form>
      </Row>
      </Col>
    </ContainerLayout>
  );
};

export default RecoverPassword;
